<template>
    <div>
        <div v-if="globalError" class="error-box section-spacing-md">{{ globalError }}</div>

        <form ref="formRef" :action="action" method="POST" class="form-stack form-stack-sm">
            <input type="hidden" name="_token" :value="csrfToken" />
            <input type="hidden" name="form_rendered_at" :value="formRenderedAt" />
            <input
                type="text"
                name="website"
                value=""
                tabindex="-1"
                autocomplete="off"
                aria-hidden="true"
                class="visually-hidden"
            />

            <input v-if="creatorLocked" type="hidden" name="creator_name" :value="creatorName" />
            <input v-if="creatorLocked" type="hidden" name="creator_email" :value="creatorEmail" />

            <PollCreateWizard
                :form-data="localFormData"
                :errors="normalizedErrors"
                :processing="false"
                :editing="false"
                :html-field-names="true"
                :use-date-modal="true"
                :show-creator-fields="showCreatorFields || creatorLocked"
                :creator-locked="creatorLocked"
                :creator-name="creatorName"
                :creator-email="creatorEmail"
                :format-readable-date="formatReadableDate"
                @open-date-modal="showPollDateModal = true"
                @open-close-date-modal="showPollCloseDateModal = true"
                @submit="submitForm"
                @cancel="cancelForm"
            />
        </form>

        <MultiDatePickerModal
            :show="showPollDateModal"
            title="Datums kiezen"
            :model-value="localFormData.options"
            @update:modelValue="localFormData.options = $event"
            @close="showPollDateModal = false"
        />

        <DatePickerModal
            :show="showPollCloseDateModal"
            title="Sluitdatum kiezen"
            :model-value="localFormData.closes_at"
            @update:modelValue="localFormData.closes_at = $event"
            @close="showPollCloseDateModal = false"
        />
    </div>
</template>

<script setup>
import DatePickerModal from '@/Components/DatePickerModal.vue'
import MultiDatePickerModal from '@/Components/MultiDatePickerModal.vue'
import PollCreateWizard from '@/Components/PollCreateWizard.vue'
import { computed, reactive, ref } from 'vue'

const props = defineProps({
    action: { type: String, required: true },
    csrfToken: { type: String, required: true },
    formRenderedAt: { type: [String, Number], required: true },
    showCreatorFields: { type: Boolean, default: true },
    creatorLocked: { type: Boolean, default: false },
    creatorName: { type: String, default: '' },
    creatorEmail: { type: String, default: '' },
    globalError: { type: String, default: '' },
    errors: { type: Object, default: () => ({}) },
    formData: { type: Object, required: true },
})

const formRef = ref(null)
const showPollDateModal = ref(false)
const showPollCloseDateModal = ref(false)
const localFormData = reactive(JSON.parse(JSON.stringify(props.formData || {})))

const normalizedErrors = computed(() => {
    const firstError = (value) => Array.isArray(value) ? (value[0] || null) : value
    return {
        creator_name: firstError(props.errors?.creator_name),
        creator_email: firstError(props.errors?.creator_email),
        title: firstError(props.errors?.title),
        options: firstError(props.errors?.options),
    }
})

const submitForm = () => {
    if (!formRef.value) {
        return
    }
    formRef.value.requestSubmit()
}

const cancelForm = () => {
    window.location.href = '/prikker'
}

const formatReadableDate = (dateString) => {
    if (!dateString) {
        return null
    }

    return new Date(dateString).toLocaleDateString('nl-NL', {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
    })
}
</script>
